import { readStorage } from "../readStorage";

// const cacheVersion = process.env.REACT_APP_CACHE_VERSION;

export function deleteAutosaveStorage(key) {
    const currentObj = readStorage('autosave_transactions') || {};
    const { [key]: oldKey, ...rest } = currentObj;

    localStorage.setItem('autosave_transactions', JSON.stringify({...rest}));
    // localStorage.setItem('cache_version', cacheVersion);
}
